export const presetsLength = state => state.presets.length

export const findPreset = (state, id) => state.presets.find(s => s.id === id)

export const sortedPresets = state => state.presets.sort((a, b) => a.description > b.description)

export const isLoaded = state => state.isLoaded

export default {
  findPreset,
  isLoaded,
  presetsLength,
  sortedPresets
}
